import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

// Import job components (lazy-loaded for performance)
const JobsList = React.lazy(() => import("./JobsList"));
const NewJob = React.lazy(() => import("./NewJob"));
const JobDetails = React.lazy(() => import("./JobDetails"));

const jobsModuleConfig: ModuleConfig = {
    // Module Identity
    id: "jobs",
    name: "Job Definitions",
    description: "Define recurring jobs and tasks with frequency, time windows, and requirements",
    version: "1.0.0",
    enabled: true,
    category: "operations",
    order: 6,
    icon: "📋",
    color: "#38A169",

    // Routes
    routes: [
        {
            path: "/jobs",
            component: JobsList,
            permissions: ["ADMIN"]
        },
        {
            path: "/jobs/new",
            component: NewJob,
            permissions: ["ADMIN"]
        },
        {
            path: "/jobs/:id",
            component: JobDetails,
            permissions: ["ADMIN"]
        },
        {
            path: "/jobs/edit/:id",
            component: NewJob, // Reuse NewJob component for editing
            permissions: ["ADMIN"]
        }
    ],

    // Navigation
    navigation: [
        {
            label: "All Jobs",
            path: "/jobs",
            icon: "📋",
            permissions: ["ADMIN"]
        },
        {
            label: "Create Job",
            path: "/jobs/new",
            icon: "➕",
            permissions: ["ADMIN"]
        },
        {
            label: "Daily Jobs",
            path: "/jobs?filter=daily",
            icon: "📅",
            permissions: ["ADMIN"]
        },
        {
            label: "Weekly Jobs",
            path: "/jobs?filter=weekly",
            icon: "🗓️",
            permissions: ["ADMIN"]
        }
    ],

    // Permissions
    permissions: {
        view: ["ADMIN"],
        create: ["ADMIN"],
        edit: ["ADMIN"],
        delete: ["ADMIN"]
    },

    // Quick Actions
    quickActions: [
        {
            label: "Create Job",
            path: "/jobs/new",
            icon: "➕",
            description: "Define a new recurring job"
        },
        {
            label: "Daily Jobs",
            path: "/jobs?filter=daily",
            icon: "📅",
            description: "View daily recurring jobs"
        },
        {
            label: "Care Jobs",
            path: "/jobs?filter=care",
            icon: "❤️",
            description: "View care-related jobs"
        }
    ]
};

export default jobsModuleConfig;
